import { Component, OnInit, Input, ViewChild } from '@angular/core';

import { ConfirmationService, MenuItem } from 'primeng/api';
import { MessageService } from 'primeng/api';

// Export
import * as FileSaver from 'file-saver';
import { ExportService } from 'src/app/shared/services/export.service';

// Model
import { Table } from 'primeng/table';
import { MyRankedWineCrudService } from 'src/app/shared/services/my-ranked-wine-crud.service';
import { RankedWine } from 'src/app/shared/interfaces/ranked-wine';

// import { Wine } from '../shared/interfaces/organisation';

import { BehaviorSubject } from 'rxjs';
import { Wine } from 'src/app/shared/interfaces/wine';
import { AuthService } from 'src/app/shared/services/auth.service';
import { WineCrudService } from 'src/app/shared/services/wine-crud.service';

@Component({
  selector: 'app-my-ranked-wines',
  templateUrl: './my-ranked-wines.component.html',
  styleUrls: ['./my-ranked-wines.component.scss']
})
export class MyRankedWinesComponent implements OnInit {

  userId : string = '';
  userId$: BehaviorSubject<string> = new BehaviorSubject<string>('undefined');

  myRankedWines: RankedWine[];
  myRankedWine: RankedWine;
  selectedRankedWine: RankedWine[] = [];

  wines: Wine[];
  winesMap : Map<string,boolean>;

  myRankedWineDialog: boolean = false;

  submitted: boolean = false;

  // column management
  cols: any[] = [];
  _selectedColumns: any[] = [];

  // export
  @ViewChild('dt', {static: true}) dt : any;
  exportColumns: any[] = [];

  // ui beadcrumb
  breadcrumbs: MenuItem[];
  homeBreadcrumb: MenuItem = {} as MenuItem;

  hideWhenNoPallet: boolean = false;
  noData: boolean = false;
  preLoader: boolean = true;

  separatorExp: string = "[,| ]";

  constructor(
    public authService : AuthService,
    private myRankedWineService : MyRankedWineCrudService,
    private organisationService : WineCrudService,
    private confirmationService: ConfirmationService,
    private messageService: MessageService,
    private exportService: ExportService
  ) { 
    // ui breadcrumbs
    this.breadcrumbs = [
      {label: 'My Wines'}
    ];

    this.myRankedWines = [];
    this.myRankedWine = { } as RankedWine ;

    this.wines = [];
    this.winesMap = new Map<string,boolean>();
  }

  async ngOnInit() {

    this.isFilter = false;
    
    await this.dataState();

    this.authService.user$.subscribe( (user: any) => {
      if (user) {
        
        this.userId = user.uid;

        let s = this.myRankedWineService.getList( user.uid ); 
        s.snapshotChanges().subscribe(data => {
          this.myRankedWines = [];
          data.forEach(item => {
            let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
            if (jsonItem) {
              if (jsonItem) {
                jsonItem['$key'] = item.key;
              }
              let l : RankedWine = jsonItem as RankedWine;
              if (l.tags) {
                l.tags = Object.values(l.tags);
              }
              this.myRankedWines.push(l);
            }
          })
        });

      } else {
        this.userId = 'undefined';
      }
    });

    
    let o = this.organisationService.getList(); 
    o.snapshotChanges().subscribe(data => {
      this.wines = [];
      data.forEach(item => {
        let jsonItem : { '$key': string | null } = item.payload.toJSON() as { '$key': string | null } ; 
        if (jsonItem) {
          if (jsonItem) {
            jsonItem['$key'] = item.key;
          }
          let l : RankedWine = jsonItem as RankedWine;
          if (l.tags) {
            l.tags = Object.values(l.tags);
          }
          this.wines.push(l);
         // this.winesMap.set( l.$key , l.isPublic || false);
        }
      })
    });

    // column management
    this.cols = [
      { field: 'name', header: 'Name' },
      { field: 'qrcode', header: 'QRCode' },
      { field: 'description', header: 'Description' },
      { field: 'tags', header: 'Tags' },
      { field: 'isPublic', header: 'Public' },
      { field: 'isEnabled', header: 'Enabled' },
      { field: 'actions', header: 'Actions' } 
    ];

    // column that we shoa at the beginning
    this._selectedColumns = this.cols;
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'qrcode');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'description');
    this._selectedColumns = this._selectedColumns.filter( item => item.field !== 'isEnabled');

    // Exports
   // this.exportColumns = this.cols.map(col => ( {title: col.header, dataKey: col.field} ) );
   // For the PDF 
   this.exportColumns = this.cols.map(col => {
      if (col.field === 'position' || col.field === 'rank')  
        return {title: col.header, dataKey: 'position'};
      if (col.field !== 'actions')  
        return {title: col.header, dataKey: col.field};
      return {};
    } );
  }

  async dataState() {     
    const u = await this.authService.user$;
    //this.userId = u.uid;
    this.userId$.next( u.uid );
    // this.myRankedWineService.getList().valueChanges().subscribe(data => {
    //   this.preLoader = false;
    //   if(data.length <= 0){
    //     this.hideWhenNoPallet = false;
    //     this.noData = true;
    //   } else {
    //     this.hideWhenNoPallet = true;
    //     this.noData = false;
    //   }
    // })
  }

  includesCol(val: string) : boolean{
    let c = this._selectedColumns.find(c => c.field === val);
    return c;
  }

  // Column management
  @Input() get selectedColumns(): any[] {
    // console.log('selected columns', this._selectedColumns);
    return this._selectedColumns;
  }
  set selectedColumns(val: any[]) {
    //restore original order
    // console.log('before selected columns', this._selectedColumns);
    // console.log('before cols', this._selectedColumns);
    this._selectedColumns = this.cols.filter(col => val.includes(col));
    // console.log('after selected columns', this._selectedColumns);
  }

  // Export management
  exportPdf() {
    import("jspdf").then(jsPDF => {
        import("jspdf-autotable").then(x => {
            const doc = new jsPDF.default('l','pt');
            // @ts-ignore
            doc.autoTable(this.exportColumns, this.myRankedWines);
            doc.save('myRankedWines.pdf');
        })
    })
  }

  exportExcel() {
    import("xlsx").then(xlsx => {
        const worksheet = xlsx.utils.json_to_sheet(this.myRankedWines);
        const workbook = { Sheets: { 'data': worksheet }, SheetNames: ['data'] };
        const excelBuffer: any = xlsx.write(workbook, { bookType: 'xlsx', type: 'array' });
        this.saveAsExcelFile(excelBuffer, "myRankedWines");
    });
  }

  exportDTCSV() {
   // console.log('export csv');
    this.dt.exportCSV();
  }

  exportToCsv(): void {
    let exportCols : string[] = [];
    this.selectedColumns.forEach( sc => 
      { exportCols.push(sc.field);
        // console.log('SAVEC CSV COL F ',sc.field);
        // console.log('SAVEC CSV COL ',sc);
      });
      exportCols.push('position');
      // console.log('SAVEC CSV SELECTED LOCATIONS ', this.selectedRankedWine);
      // console.log('SAVEC CSV LOCATIONS ', this.myRankedWines);
      // console.log('SAVEC CSV EXPORT COL ', exportCols);
      this.exportService.exportToCsv(this.selectedRankedWine, 'myRankedWines', exportCols);
   // this.exportService.exportToCsv(this.myRankedWines, 'myRankedWines', ['$key', 'name', 'description', 'tags', 'isEnabled', 'actions']);
  }

  saveAsExcelFile(buffer: any, fileName: string): void {
    let EXCEL_TYPE = 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
    let EXCEL_EXTENSION = '.xlsx';
    const data: Blob = new Blob([buffer], {
        type: EXCEL_TYPE
    });
    FileSaver.saveAs(data, fileName + '_' + new Date().getTime() + EXCEL_EXTENSION);
  }

  // CRUD management
  openNew() {
    this.myRankedWine = {} as RankedWine;
    this.submitted = false;
    this.myRankedWineDialog = true;
  }

  deleteSelectedMyWines() {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete the selected myRankedWines?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.myRankedWines = this.myRankedWines.filter(val => !this.selectedRankedWine.includes(val));
            
            this.selectedRankedWine.forEach( myRankedWine => this.myRankedWineService.delete(this.userId, myRankedWine.$key));
            this.selectedRankedWine = [];
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'MyWiness Deleted', life: 3000});
        }
    });
  }

  editMyWine(myRankedWine: RankedWine) {
    this.myRankedWine = {...myRankedWine};
    this.myRankedWineDialog = true;
  }

  deleteMyWine(myRankedWine: RankedWine) {
    this.confirmationService.confirm({
        message: 'Are you sure you want to delete ' + myRankedWine.name + '?',
        header: 'Confirm',
        icon: 'pi pi-exclamation-triangle',
        accept: () => {
            this.myRankedWines = this.myRankedWines.filter(val => val.$key !== myRankedWine.$key);
            this.myRankedWine = {} as RankedWine;
            this.myRankedWineService.delete(this.userId, myRankedWine.$key);
            this.messageService.add({severity:'success', summary: 'Successful', detail: 'MyWine Deleted', life: 3000});
        }
    });
  }

  hideDialog() {
    this.myRankedWineDialog = false;
    this.submitted = false;
  }

  saveMyWine() {
    this.submitted = true;

    if ( this.myRankedWine.name.trim() ) {
      if (this.myRankedWine.$key) {
        
        // if (!this.myRankedWine.ownerKey) {
        //   this.myRankedWine.ownerKey = this.userId;
        // }
        
        this.myRankedWines[this.findIndexById(this.myRankedWine.$key)] = this.myRankedWine;                
          this.messageService.add({severity:'success', summary: 'Successful', detail: 'MyWine Updated', life: 3000});
          this.myRankedWineService.update( this.userId, this.myRankedWine);
        
         // if (this.myRankedWine.isPublic) {
            if (!this.winesMap.has(this.myRankedWine.$key) ) {
              const publicWine : Wine = Object.assign({}, this.myRankedWine);
              publicWine.position = this.wines.length;
              publicWine.$key = this.myRankedWine.$key ;
              publicWine.key = this.myRankedWine.$key ;
              this.organisationService.update( publicWine );
            }
         // } 
        
        } else {
          this.myRankedWine.position = this.myRankedWines.length;

        //  this.myRankedWine.ownerKey = this.userId;

          const ref = this.myRankedWineService.add(this.userId,this.myRankedWine);
          console.log('NEW KEY', ref.key);

         // if (this.myRankedWine.isPublic) {
            const publicWine : Wine = Object.assign({}, this.myRankedWine);
            publicWine.position = this.wines.length;
            publicWine.$key = ref.key || 'na';
            publicWine.key = ref.key || 'na';
          //  publicWine.ownerKey = this.userId;
            this.organisationService.update( publicWine );
          // } else {

          // }
      }
      this.messageService.add({severity:'success', summary: 'Successful', detail: 'MyWine Created', life: 3000});
      this.myRankedWines = [...this.myRankedWines];
    }

    this.myRankedWineDialog = false;
    this.myRankedWine = { } as RankedWine;
  }

  findIndexById(id: string): number {
    let index = -1;
    for (let i = 0; i < this.myRankedWines.length; i++) {
        if (this.myRankedWines[i].$key === id) {
            index = i;
            break;
        }
    } 
    return index;
  }

  filter( dt : Table, event : {target: any} ) {
    dt.filterGlobal( (event.target as HTMLInputElement).value, 'contains')
  }

  completeMyWine(myRankedWine : RankedWine) {
    this.myRankedWineService.update(this.userId,myRankedWine);
  }

  completePosition(myRankedWine : RankedWine) {
    if ( this.newPosition > -1 ) {
        myRankedWine.position = this.newPosition;
        myRankedWine = this.checkPositionLimits(myRankedWine);
        this.reorderElements(myRankedWine);
        //this.updateDB(myRankedWine);
        this.newPosition = -1;
        this.previousPosition = -1;
        return;
      }
  }


  @ViewChild('dt') tableElement: any; // already dt above
  isReordering : boolean = false;
  isAscReordering : boolean = false;
  isFilter : boolean = false;

  // Reorder
  reorder(event: any) {
    //console.log('Reorder event', event);
    // console.log('Before', this.myRankedWines);
    // const myClonedArray = [];
    // this.myRankedWines.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // console.log('Before2', myClonedArray);
    if (event.dragIndex === event.dropIndex ) {
      return;
    }
    const startIndex = this.isAscReordering? event.dragIndex : this.myRankedWines.length - 1 - event.dragIndex;
    const endIndex   = this.isAscReordering? event.dropIndex : this.myRankedWines.length - 1 - event.dropIndex;
    const myRankedWineToMove = this.myRankedWines[startIndex];

    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {
        this.myRankedWines[index] = this.myRankedWines[index+1];
        this.myRankedWines[index].position = index;
        this.myRankedWineService.update(this.userId,this.myRankedWines[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.myRankedWines[index] = this.myRankedWines[index-1];
        this.myRankedWines[index].position = index;
        this.myRankedWineService.update(this.userId,this.myRankedWines[index]);
      }
    } 
    this.myRankedWines[endIndex] = myRankedWineToMove;
    this.myRankedWines[endIndex].position = endIndex;
    this.myRankedWineService.update(this.userId,this.myRankedWines[endIndex]);
  }

  // onFieldEdit(myRankedWine: Spray, fieldName: string): void {
  //   //console.log(this.myRankedWines);
  //   console.log("Edit Init Event Called");
  //   console.log('Field name :'+fieldName);
  //   console.log('Field value :' + myRankedWine[fieldName]);
  //   if (fieldName === 'position') {
  //     if ( this.newPosition ) {
  //       myRankedWine.position = this.newPosition;
  //       myRankedWine = this.checkPositionLimits(myRankedWine);
  //       this.reorderElements(myRankedWine);
  //       //this.updateDB(myRankedWine);
  //       this.newPosition = undefined;
  //       this.previousPosition = undefined;
  //       return;
  //     }
      
  //   } else {
  //     this.updateDB(myRankedWine);
  //   }
  // }


  ngAfterViewInit() {
    this.dt.onSort.subscribe((data: { field: string; order: number; }) => {
        if (data.field && data.field === "position") {
          this.isReordering = true;
          this.isAscReordering = (data.order == 1);
          // console.log("ASC", this.isAscReordering);
          // console.log("data.order", data.order);
        } else {
          this.isReordering = false;
        }
    });
    this.dt.onFilter.subscribe( (data: {
      filteredValue: {
        [x: string]: any; field: string; order: number; 
}; field: string; order: number; 
}) => {
      if (data && data.filteredValue) {
        this.isFilter = !(this.myRankedWines.length === data.filteredValue['length']);
      } else {
        this.isFilter = false;
      }
  });
  
}


  previousPosition : number = -1;
  newPosition : number = -1;

  modelChangeFn(event: number, myRankedWine: RankedWine) {
    // console.log("event" +event);
    if (myRankedWine.position != null && myRankedWine.position > -1) {
      this.previousPosition = myRankedWine.position;
      this.newPosition = event;
    }
   
    // console.log("previous" +this.previousPosition);
    // console.log("new" +this.newPosition);
  }

  checkPositionLimits(myRankedWine: RankedWine) {
    console.log('check ',myRankedWine.position + ' ' + this.myRankedWines.length);
    if (!myRankedWine.position) {
     // console.log('check 1');
      return this.myRankedWine;
    }
    if (myRankedWine.position < 0) {
      myRankedWine.position = 0;
      // console.log('check 2');
      return myRankedWine;
    }
    if (myRankedWine.position > this.myRankedWines.length) {
      myRankedWine.position = this.myRankedWines.length - 1;
    //  console.log('check 3', myRankedWine.position);
      return myRankedWine;
    }
   // console.log('check 4');
    return myRankedWine;
  }

  async reorderElements(myRankedWine: RankedWine) {
    this.newPosition = this.newPosition  > this.myRankedWines.length ? this.myRankedWines.length - 1 : this.newPosition;
    this.newPosition = this.newPosition  < 0 ? 0 : this.newPosition;
    if (this.previousPosition === myRankedWine.position ) {
      return;
    }
    // console.log('Previous position: '+ this.previousPosition);
    // console.log('New position: '+ this.newPosition);
    const startIndex = this.previousPosition;
    const endIndex   = this.newPosition;
    const myRankedWineToMove = this.myRankedWines[startIndex];
   // console.log('Item to move: ', this.myRankedWines[startIndex]);
    if (startIndex < endIndex) {
      for(let index = startIndex; index < endIndex; index++) {

        console.log('LOC', this.myRankedWines);
        console.log('Item to +1: ', this.myRankedWines[index+1]);

        this.myRankedWines[index] = this.myRankedWines[index+1];
        this.myRankedWines[index].position = index;
        // console.log('Move: ', this.myRankedWines[index+1]);
        // console.log('Move pos: ', this.myRankedWines[index].position);
        //await this.updateDB(this.myRankedWines[index]);
        this.myRankedWineService.update(this.userId,this.myRankedWines[index]);
     //   console.log('Update DB: ', this.myRankedWines[index]);
      }     
    } else {
      for(let index = startIndex; index > endIndex; index--) {
        this.myRankedWines[index] = this.myRankedWines[index-1];
        this.myRankedWines[index].position = index;
        this.myRankedWineService.update(this.userId,this.myRankedWines[index]);
      }
    } 
    this.myRankedWines[endIndex] = myRankedWineToMove;
    this.myRankedWines[endIndex].position = endIndex;
    this.previousPosition = -1;
    this.newPosition = -1;
    this.myRankedWineService.update(this.userId,this.myRankedWines[endIndex]);
    
    // const myClonedArray = [];
    // this.myRankedWines.forEach(val => myClonedArray.push(Object.assign({}, val)));
    // this.myRankedWines = myClonedArray;
   // this.getAllRecords();
  }

  alreadyTaken(value: string) {
    if (!value) {
      return false;
    }
    return this.winesMap.has(value);
  }

}
